//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import {
  mapActions,
  mapGetters,
} from 'vuex'

import {
  prefixLanguage,
} from '@utils/urls'

const WAITING_LIST_COUNT_KEY = 'waitinglistCount'
const WISH_LIST_COUNT_KEY = 'wishlistCount'
const COMPARISON_LIST_COUNT_KEY = 'comparitonCount'

export default {
  name: 'AdditionalLinks',
  data() {
    return {
      link: {
        title: this._('Отзывы'),
        tag: 'UserOrderList',
        trigger: true,
        class: 'is-disable-xl',
        events: {
          click: () => { this.trigger(true) },
        },
        icon: 'flower-trigger',
      },
      show: false,
      sidebar: [
        {
          title: this._('Список желаний'),
          text: this._('Товаров:'),
          icon: 'starfill',
          color: 'var(--theme-accent-main)',
          count: WISH_LIST_COUNT_KEY,
          href: prefixLanguage('/buyer/wishlist/'),
        },
        {
          title: this._('Список сравнения'),
          text: this._('Товаров:'),
          icon: 'libra',
          color: 'var(--theme-primary-main)',
          count: COMPARISON_LIST_COUNT_KEY,
          href: window.comparison_page,
        },
        {
          title: this._('Лист ожидания'),
          text: this._('Товаров:'),
          color: 'var(--theme-text-6)',
          count: WAITING_LIST_COUNT_KEY,
          icon: 'waiting',
          href: prefixLanguage('/buyer/waiting-list/'),
        },
      ],
    }
  },
  computed: {
    ...mapGetters('like', {
      [WISH_LIST_COUNT_KEY]: 'getCount',
    }),
    ...mapGetters('comparison', {
      [COMPARISON_LIST_COUNT_KEY]: 'getCount',
    }),
    ...mapGetters('waitinglist', {
      [WAITING_LIST_COUNT_KEY]: 'getCount',
    }),
    counters() {
      return {
        [WAITING_LIST_COUNT_KEY]: this[WAITING_LIST_COUNT_KEY],
        [COMPARISON_LIST_COUNT_KEY]: this[COMPARISON_LIST_COUNT_KEY],
        [WISH_LIST_COUNT_KEY]: this[WISH_LIST_COUNT_KEY],
      }
    },
  },
  watch: {
    $route() {
      this.recalc()
    },
  },
  created() {
    if (window.authent) this.getWaitingListIds()
  },
  methods: {
    ...mapActions('waitinglist', [
      'getWaitingListIds',
    ]),
    ...mapActions('like', [
      'getWishListIds',
    ]),
    ...mapActions('staff', [
      'getUserInfo',
    ]),
    trigger() {
      this.show = !this.show
    },
    recalc() {
      this.show = false
    },
  },

}
